<template>
  <b-card>
    <form @submit.prevent="setPreference">
      <h3 v-if="!inModal" v-translate>Add credit</h3>
      <div v-if="!free || !$store.getters.profile.company.has_credit">
        <p v-translate>How many new shippings are you planning to do?</p>
        <b-form-input v-model="projectedShippings"
          type="number"
          min="0"
          style="font-size: 1.5rem"
        ></b-form-input>
        <b-form-text v-translate>This is an approximate quantity and may vary depending on the origin and destination, size or type of each shipping</b-form-text>
      </div>
      <div v-else>
        <h4 v-translate>How much credit do you want to add?</h4>
      </div>
      <b-input-group class="my-3">
        <b-form-input
          v-model="amount"
          style="font-size: 1.5rem"
          type="number"
          :placeholder="$gettext('Amount')"
          :state="amount !== 0 ? (amount > 0 ? true : false) : null"
          step=".01"
          :min="1"
          required
        ></b-form-input>
        <template v-slot:prepend>
          <b-input-group-text><strong style="font-size: 1.5rem" v-translate>$</strong></b-input-group-text>
        </template>
      </b-input-group>
      <div class="text-center">
        <b-button variant="primary" type="submit" class="d-sm-nofne" :disabled="amount <= 0" v-translate="{paymentProviderName: paymentProvider.name}">
          Go to %{paymentProviderName}
        </b-button>
      </div>
    </form>
  </b-card>
</template>

<script>
export default {
  name: 'AddCreditForm',
  props: {
    inModal: {
      type: Boolean,
      default: false
    },
    free: {
      type: Boolean,
      default: false
    },
    paymentProvider: {
      type: Object,
      default: () => {
        return {
          name: 'MercadoPago',
          slug: 'mercado-pago'
        }
      }
    }
  },
  data() {
    return {
      countryThreshold: window.countries.find(x => x.iso_code === this.$store.getters.profile.country_iso_code).credit_threshold,
      amount: 0,
      stillNotEnough: false,
      projectedShippings: 1,
      vat: window.countries.find(x => x.iso_code === this.$store.getters.profile.country_iso_code).vat_percentage
    }
  },
  computed: {
    minCreditToOperate() {
      let credit
      if (this.$store.getters.profile.company.account.balance > 0 && this.$store.getters.profile.company.account.balance < this.countryThreshold) {
        credit = Number((Math.round((Math.abs(this.countryThreshold - this.$store.getters.profile.company.account.balance + this.$store.getters.profile.company.account.credit_limit)) * 100) / 100).toFixed(2))
      } else {
        credit = Number((Math.round((Math.abs(this.$store.getters.profile.company.account.balance) + this.$store.getters.profile.company.account.credit_limit + this.countryThreshold) * 100) / 100).toFixed(2))
      }
      return credit >= 0 ? Number((Math.round((credit + this.vat / 100 * credit) * 100) / 100).toFixed(2)) : 0
    },
    calcCredit() {
      if (!this.free || !this.$store.getters.profile.company.has_credit) {
        let credit
        if (this.$store.getters.profile.company.account.balance > 0 && this.$store.getters.profile.company.account.balance < this.countryThreshold) {
          credit = this.projectedShippings > 0 ? Number((Math.round((Math.abs(this.projectedShippings * this.countryThreshold - this.$store.getters.profile.company.account.balance + this.$store.getters.profile.company.account.credit_limit)) * 100) / 100).toFixed(2)) : 0
        } else {
          credit = Number((Math.round((Math.abs(this.$store.getters.profile.company.account.balance) + this.$store.getters.profile.company.account.credit_limit + this.projectedShippings * this.countryThreshold) * 100) / 100).toFixed(2))
        }
        return credit >= 0 ? credit : 0
      } else {
        return Number((1).toFixed(2))
      }
    },
    minCreditToAdd() {
      return Math.abs(this.$store.getters.profile.company.account.balance)
    }
  },
  watch: {
    calcCredit(val) {
      this.amount = Number((Math.round((val + this.vat / 100 * val) * 100) / 100).toFixed(2))
    }
  },
  mounted() {
    if (this.$route.query.payment_id && this.$route.query.status === 'approved') {
      this.stillNotEnough = true
    }
    this.amount = !this.free || !this.$store.getters.profile.company.has_credit ? this.minCreditToOperate : Number((1).toFixed(2))
  },
  methods: {
    setPreference() {
      const payload = {
        unit_price: this.amount,
        quantity: 1,
        title: this.$gettextInterpolate(this.$gettext('%{siteName} Credit'), { siteName: this.siteName }),
        back_urls: {
          success: location.protocol + '//' + location.host + '/new'
        }
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'platforms/' + this.paymentProvider.slug + '/preference', payload)
        .then(response => {
          if (confirm(this.$gettextInterpolate(this.$gettext('Now you will be redirected to %{paymentProvider}. Once you successfully finish the payment proccess you will come back here and your new credit will allow you to operate again.'), { paymentProvider: this.paymentProvider.name }))) {
            window.location.href = response.body.init_point
          }
        })
    }
  }
}
</script>
